// extracted by mini-css-extract-plugin
module.exports = {"main":"Main_main__3JhNz","centeredWithoutStyles":"Main_centeredWithoutStyles__1CPTf"};